import styled from 'styled-components';

export default styled.div`
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  background-color: ${p => p.theme.color.red};
  color: ${p => p.theme.color.white};

  @media (${p => p.theme.mq.mobile}) {
    position: fixed;
    top: 0;
    font-size: 13px;
  }
`;

export const DesktopInfo = styled.span`
  @media (${p => p.theme.mq.mobile}) {
    display: none;
  }
`;

export const MobileInfo = styled.span`
  @media (${p => p.theme.mq.desktop}) {
    display: none;
  }
`;



// WEBPACK FOOTER //
// ./src/components/NotificationBar/styles.js